export function getPageCurationId(pageId: string): string {
  return 'jps-' + pageId.replace(/-/g, '_')
}

export function forEachParts(
  parts: CurationPartDefinition[],
  consumer: (c: CurationPartDefinition) => void
): void {
  if (parts) {
    parts.forEach((p) => {
      consumer(p)
      if (p.parts) {
        forEachParts(p.parts, consumer)
      }
    })
  }
}

export function findPart(
  parts: CurationPartDefinition[],
  det: (c: CurationPartDefinition) => boolean
): CurationPartDefinition {
  for (let p of parts) {
    if (det(p)) return p
    else if (p.parts) {
      let r = findPart(p.parts, det)
      if (r) return r
    }
  }
  return null
}

export function filterParts(
  parts: CurationPartDefinition[],
  det: (c: CurationPartDefinition) => boolean
): CurationPartDefinition[] {
  let result = []
  parts.forEach((p) => {
    if (det(p)) {
      result.push(p)
    }
    if (p.parts) {
      result.push(...filterParts(p.parts, det))
    }
  })
  return result
}
